import AxiosService from 'plugins/TS-lib-utils-public/services/AxiosService';

class AnalysisService extends AxiosService {
  constructor() {
    super('labs');
  }

   getAnalysisList = async (practiceId, page = 0, count = 5, sortDate = 0, search = null, { cancelToken = null } = {}) => {
        let query = `/analysis/list?page=${page}&limit=${count}&datesort=${sortDate}`;

        if (search) {
            query += `&search=${search}`
        }
        
        const response = await this.get(query, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: practiceId,
            },
            cancelToken: cancelToken
        });
        return response;
    };

    getStudyTypes = async ({ cancelToken = null } = {}) => {
        return await this.get("/analysis/types", {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
            cancelToken: cancelToken
        });
    }

    saveAnalysis = async (data, { cancelToken = null } = {}) => {
        return await this.post("/analysis/", data, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
                practice: data.practice,
            },
            cancelToken: cancelToken
        });
    }

    invitePatient = async (data, { cancelToken = null } = {}) => {
        return await this.post("/analysis/patient", data, {
            headers: {
                Authorization: `Bearer ${this.getToken()}`,
            },
            cancelToken: cancelToken
        });
    }


}

export default new AnalysisService();
